
















































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { ColumnsAdjustRequestData, ColumnSortRequestData, SortedColumnInfo, SwTable, TableColumnConfig, TableEntry } from '@libs-uuif/shared/sw-table';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { DropMenuItem, SwDropMenu } from '@libs-uuif/shared/sw-drop-menu';
import { PrefFileDownlodReport } from './types';
import { SwExpandableTextfield, SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { MswApiService } from '@/shared/msw-api-service';
import { uniqueId, cloneDeep } from 'lodash';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwChip } from '@libs-uuif/shared/sw-chip';

const cssPrefix: string = 'prefFileDownloadReportPrintPrefix';

@Component({
  components: {
    MswAppTitle,
    SwContentToolbar,
    SwIconButton,
    SwDropMenu,
    SwExpandableTextfield,
    SwTable,
    SwTextfield,
    SwIcon,
    SwChip,
  },
})
export default class MswPrefFileDownloadReportPrint extends SwExtendedVue {
  cssPrefix = cssPrefix;
  sortedColumns: SortedColumnInfo[] = [];
  isLoadingData: boolean = true;
  adjustedColumns: ColumnsAdjustRequestData = {};
  tableData: PrefFileDownlodReport[] = [];
  tempTableData:  PrefFileDownlodReport[] = [];

  created() : void {
    this.fetchPrefFileData();
  }

  get tableHeight(): string {
    return 'calc(100vh - 340px)';
  }

  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'SerialNumber',
        content: 'SerialNumber',
      },
      {
        id: 'FriendlyName',
        content:'FriendlyName',
      },
      {
        id: 'Model',
        content: 'Model',
      },
      {
        id: 'productGroupName',
        content: 'Tenant Name',
      },
      {
        id: 'RegDate',
        content: 'Registered',
      },
      {
        id: 'FirmwareVersion',
        content: 'Firmware Version',
      },
      {
        id: 'PreferenceFileName',
        content: 'Preference File Name',
      },
      // {
      //   id: 'LastDownloadTime',
      //   content: 'Last Download Time',
      // },
    ];
  }

  get returnData(): TableEntry[] {
    const rowData = cloneDeep(this.tableData) || [];
    const tableEntry: TableEntry[] = [];
    rowData.forEach((data: PrefFileDownlodReport) => {
      const entry: TableEntry = {
        ...data,
        _key: uniqueId(),
      };
      tableEntry.push(entry);
    });
    return tableEntry;
  }

  get getColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'SerialNumber',
        dataKey: 'SerialNumber',
        title: 'SerialNumber',
        sorter: true,
        width: 150,
      },
      {
        key: 'FriendlyName',
        dataKey: 'FriendlyName',
        title: 'Friendly Name',
        sorter: true,
        width: 200,
      },
      {
        key: 'Model',
        dataKey: 'Model',
        title: 'Model',
        sorter: true,
      },
      {
        key: 'productGroupName',
        dataKey: 'productGroupName',
        title: 'Tenant Name',
        sorter: true,
      },
      {
        key: 'RegDate',
        dataKey: 'RegDate',
        title: 'registered',
        sorter: true,
      },
      {
        key: 'FirmwareVersion',
        dataKey: 'FirmwareVersion',
        title: 'Firmware Version',
      },
      {
        key: 'PreferenceFileName',
        dataKey: 'PreferenceFileName',
        title: 'Preference File Name',
      },
      // {
      //   key: 'LastDownloadTime',
      //   dataKey: 'LastDownloadTime',
      //   title: 'Last Download Time',
      // },
    ] as TableColumnConfig[];
  }

  public onRequestAdjustColumns(data: ColumnsAdjustRequestData): void {
    this.adjustedColumns = data;
  }

  public onRequestSorting(data: ColumnSortRequestData): void {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  public fetchPrefFileData() : void {
    this.tableData  = [];
    this.isLoadingData = true;
    this.$store.commit('startLoading');
    const userId = this.$store.getters.getUserId;
    MswApiService.preffileReport.getPreffileReport({ username: userId })
      .then((res: any) => {
        this.tableData = (res.content.Records as PrefFileDownlodReport[]) || [];
        this.tempTableData = cloneDeep(this.tableData);
      })
      .catch((errRes: Error) => {
        console.error(errRes);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
        this.isLoadingData = false;
      });
  }
}
